import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { toggleButton } from "../../../redux-slicer/toggleButton";
import { activateCanvas, deactivateCanvas } from "../../../redux-slicer/activeCanvas";
import { } from '../../../store/store'
import '../style.css'


function MeasureButton() {
    const btn = useSelector((state) => state.toggleButton.measureBtn);
    const btnText = btn.text;
    const [state, setState] = useState(btn.active);
    const dispatch = useDispatch();
    useEffect(() => {
        setState(!state);
        dispatch(deactivateCanvas());
        if (state) {
            dispatch(activateCanvas('.measureCanvas'))
        }
        
    }, [btn]);
    return (
        <>
            <button className="measure-btn control-btn" onClick={() => {
                dispatch(toggleButton('RESET_ALL_BUTTONS'))
                dispatch(toggleButton('measure'))
            }}>
                {btnText}
            </button>
        </>
    );
}
export default MeasureButton